import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.roles.title',
    defaultMessage: 'Manage Roles',
  },
});

function AdminRolesPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Roles.List />
    </AdminManagement.Layout>
  );
}

export default AdminRolesPage;
